/* ==========================================================================
  product.js
========================================================================== */

jQuery('document').ready(function($){
  // Extra information
  $('.myrtilli-extra-info-button').on('click', function(e){
    e.preventDefault();
    if ($('.myrtilli-extra-info-button').text().indexOf("+") >= 0) {
      $('.myrtilli-extra-info-button').fadeOut(333, function() {
        $(this).html("- LIS&Auml;&Auml;").fadeIn(333);
      });
    } else {
      $('.myrtilli-extra-info-button').fadeOut(333, function() {
        $(this).html("+ LIS&Auml;&Auml;").fadeIn(333);
      });
    }
    $('.woocommerce-product-extra-information').toggle('fast');
  });

  // Plus / minus -buttons
  $('#myrtilli-product-card-plus').on('click', function(e){
    e.preventDefault();
    $('.input-text').val( function(i, oldval) {
      return ++oldval;
    });
  });

  $('#myrtilli-product-card-minus').on('click', function(e){
    e.preventDefault();
    $('.input-text').val(function(i, oldval) {
      if (oldval < 1) {
        return 0;
      }
      return --oldval;
    });
  });
});
